<script>
  import options from './GalleryCard.options'
  export default options
</script>

<template>
  <a :href="result.href" class="kb-gallery-card-link">
    <article class="kb-gallery-card">
      <div class="kb-gallery-card__left">
        <div class="kb-gallery-card__left__date">{{ result.numberOfImages }} {{ getLabel('imagesLabel') }}</div>
        <h3 class="kb-gallery-card__left__title">{{ result.title }}</h3>
        <p class="kb-gallery-card__left__description">{{ result.description }}</p>
        <div class="kb-gallery-card__left__date kb-gallery-card__left__date--mobile">{{ result.numberOfImages }} {{ getLabel('imagesLabel') }}</div>
      </div>
      <div class="kb-gallery-card__right">
        <div class="kb-gallery-card__right__image-wrapper">
          <figure>
            <picture> 
              <img class="kb-gallery-card__right__image-wrapper-img" :src="result.image.src" :alt="result.image.alt" />
            </picture>
          </figure>
          <div class="kb-gallery-card__right__image-wrapper-info">
            <div class="kb-gallery-card__right__image-wrapper-icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24"><path fill="#fff" d="M22.546 9.21V6.42H16.91c-.41-.559-1.652-1.815-4.41-1.815-2.757 0-3.996 1.256-4.409 1.814H2.453v13.117h20.093v-8.93h-2.232v.837h1.395v7.255H3.29V7.257H21.71V9.21h.837ZM12.5 5.443c1.674 0 2.687.524 3.245.976h-6.49c.557-.452 1.57-.976 3.245-.976Z"/><path fill="#fff" d="M7.895 12.978a4.605 4.605 0 1 0 9.209 0 4.605 4.605 0 0 0-9.21 0Zm8.372 0a3.767 3.767 0 1 1-7.535 0 3.767 3.767 0 0 1 7.535 0Z"/><path fill="#fff" d="M12.5 16.186a3.21 3.21 0 1 0 0-6.418 3.21 3.21 0 0 0 0 6.418ZM20.315 8.373h-2.233v.837h2.233v-.837Z"/></svg>
            </div>
            <div class="kb-gallery-card__right__image-wrapper-info-text">
              {{ result.numberOfImages }} {{ getLabel('imagesLabel') }}
            </div>
          </div>
        </div>
      </div>
    </article>
  </a>
</template>
